export const CASHIER_OPEN_BALANCE_REQUEST = "CASHIER_OPEN_BALANCE_REQUEST";
export const CASHIER_OPEN_BALANCE_SUCCESS = "CASHIER_OPEN_BALANCE_SUCCESS";
export const CASHIER_OPEN_BALANCE_FAILURE = "CASHIER_OPEN_BALANCE_FAILURE";
